// extracted by mini-css-extract-plugin
export default {"container":"InputGroup_container__y8xzw","submitBtn":"InputGroup_submitBtn__XHorG"};